var DK = DK || {};
DK.Search = {};

/**
 * Submit an AJAX request to the given URL
 * @param href URL to request
 * @param params Query string to send as data. Usually used for multiple
 *               selections where the facets cannot be encoded at page render.
 */
DK.Search.submitRequest = function (href, params) {
  let spinner = new Spinner({
      position: 'fixed'
    }),
    $content = $('.page-content'),
    $modal = $('#filter-modal'),
    $modalContent = $modal.find('.modal-content'),
    isModal = $modal.is(':visible');
  return $.ajax({
    url: href,
    cache: true,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    timeout: 15000,
    data: JSON.stringify(params),
    type: 'POST',
    processData: false,
    beforeSend: function () {
      if (isModal) {
        // Display blocker for mobile filters
        DK.displayBlocker($modalContent);
      }
      DK.displayBlocker($content);
      spinner.spin($content.get()[0]);
    },
    complete: function () {
      if (isModal) {
        // Hide blocker for mobile filters
        DK.hideBlocker($modalContent);
      }
      DK.hideBlocker($content);
      spinner.stop();
    }
  }).done(function (data) {
    DK.Search.applyJson(data);
    DK.lazy();
    DK.PriceSlider.init();
    DK.HandlebarSliders.init();
    $('[data-tire-size-selector]').sizeselector();
    DK.Search.Seo.hideLongLists();
    $(document).productCompare('resetPanel');
    DK.Search.Seo.updateContentTitle(data.defaultTitle, data.customTitle, data.landingPageHtml);
    $('input[data-facet-filter]').facetSearch();
    $('[data-morty]').morty();

    //Reinitialize Affirm
    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
      affirm.ui.refresh();
    }

    // MOBILE BEHAVIOR
    // When clicking on a filter, scroll the filters so that active
    // filter group stays visible to the user.
    if (isModal) {
      if (params) {
        let $activeGroup = $('#filter-modal').find(`[data-group-name="${params.parameterName}"]`).parents('.facets-group');
        if ($activeGroup.is(':visible')) {
          // Scroll to the top of the open filter group
          $modal.scrollTop($activeGroup.offset().top - $modal.offset().top + $modal.scrollTop());
        } else if ($activeGroup.length) {
          // Scroll to the top of the modal when the filter group is
          // no longer visible (not multi-selectable)
          $modal.scrollTop(0);
        }
      } else {
        // Scroll to the top of the modal when the parameter is unknown
        $modal.scrollTop(0);
      }
    }
  });
};
DK.Search.applyJson = function (data) {
  if (data.breadcrumb) {
    $('nav.bc').remove();
    $(data.breadcrumb).insertBefore('.overview-content');
  } else {
    $('nav.bc').remove();
  }
  $('[data-search-filters]').replaceWith(data.filters);
  if (data.products) {
    $('[data-search-content]').replaceWith(data.products);
  } else if (data.landingPageHtml) {
    $('[data-search-content]').replaceWith(data.landingPageHtml);
  }
  $('.results').text(data.productCount);
  $('.pls-pagination__dd-toggle span').text('| ' + data.selectedSortOption);
  $('#mmy-tabs').replaceWith(data.rideBar);
  DK.Search.Seo.updateSeoContent(data);
  if (data.displaySpecTab !== true) {
    $('.spec-tab').removeClass('tab-active');
    $('#specs-wrapper , #change-wrapper').hide();
  } else {
    $('#specifications .spec-tab').addClass('tab-active');
    $('#specs-wrapper').show();
  }

  //remove current ride selector
  $('.rf').remove();

  //add new ride selector html
  $(data.rideSelector).insertAfter('.nav-main');
  if (data.resultCount === 0) {
    $('.page-content').addClass('no-search-results');
  } else {
    $('.page-content').removeClass('no-search-results');
  }
};
DK.Search.updateListing = function (href, params) {
  return DK.Search.submitRequest(href, params).done(function (data) {
    let historyContent = {
      url: data.url
    };
    history.pushState({
      content: historyContent,
      searchFilters: true
    }, document.title, DK.url(data.url));
  }).done(function (data) {
    ga('set', 'page', data.url);
    ga('send', 'pageview');
    if (data.productCount === 0) {
      let keyword = $('#no-results-message').data('gaMessage') || $('#search-keyword').text();
      ga('send', 'event', 'Search', 'No Results', keyword);
    }
  });
};
$(function () {
  let noResultsMessage = $('#no-results-message'),
    keyword = noResultsMessage.data('gaMessage') || $('#search-keyword').text(),
    spellcheck = noResultsMessage.data('gaSpellcheck') || null,
    exactFitTab = $('#exact-fit'),
    possibleFitTab = $('#possible-fit'),
    rideName = $('#active-ride-bar-spec').find('[data-active-ride-name]').data('activeRideName'),
    isRideActive = $('#ride-bar-state').is(':checked'),
    hasNoProducts = $('[itemtype="http://schema.org/ListItem"]').length === 0;
  if (hasNoProducts || spellcheck) {
    // Send an event when the original keyword being searched for has no results
    if (isRideActive) {
      ga('send', 'event', 'Search', 'No Results', 'Keyword=' + keyword + '; Ride=' + rideName);
    } else {
      ga('send', 'event', 'Search', 'No Results', keyword);
    }
  }
  if (spellcheck) {
    // Send an event when there is a spelling suggestion
    ga('send', 'event', 'Search', 'Spelling Suggestion', 'Keyword=' + keyword + '; Suggestion=' + spellcheck);
  }

  // Handle ride tab events
  if (exactFitTab.length > 0 || possibleFitTab.length > 0) {
    // Construct the event label. Keyword and spelling suggestion will
    // be added if applicable.
    // Ride=<ride name>[; Keyword=<search phrase>[; Suggestion=<spelling suggestion>]]
    let gaEventLabel = 'Ride=' + rideName;
    let spellcheckSuffix = spellcheck != null ? ' with Spellcheck' : '';
    if (keyword) {
      gaEventLabel += '; Keyword=' + keyword;
      if (spellcheck) {
        gaEventLabel += '; Suggestion=' + spellcheck;
      }
    }

    // Construct the event action. It will have 'Only' in it for
    // searches that only display a single tab and 'With Spellcheck' if
    // a spellcheck occurred.
    // <fitment type> Fit[ Only][ With Spellcheck]
    let gaEventAction;
    if (exactFitTab.hasClass('active')) {
      gaEventAction = 'Exact Fit';
    } else {
      gaEventAction = 'Possible Fit';
    }
    if (possibleFitTab.hasClass('unselectable') || exactFitTab.hasClass('unselectable')) {
      gaEventAction += ' Only';
    }
    ga('send', 'event', 'Search', gaEventAction + spellcheckSuffix, gaEventLabel);
  }
});

/**
 * Determine which filter group is being manipulated and what the active
 * facets within the group are. This allows the search to offer expanded
 * facets for multiselect capabilities. Without this, most facets would
 * become invalid once a facet is selected and prevent selecting multiple
 * facets at once.
 */
$(document).on('applyFilter', function (e, $facet) {
  e.preventDefault();
  let $parentFilterGroup = $facet.parents('form'),
    href = $facet.find('> a').attr('href') || $facet.find('> a').attr('data-url'),
    $parents = $facet.parents('.facets-list');
  if (!$facet.attr('data-facet') || !mapElementToFacet(0, $facet).multiSelectable) {
    // No need to reconstruct the filter group for the server. Only
    // one of these facets can be selected at a time.
    return DK.Search.updateListing(href).done(function (data) {
      ga('set', 'page', data.defaultCanonical);
      ga('send', 'pageview');
    });
  }
  let facets = undefined;
  if ($parents.length === 1) {
    facets = $parentFilterGroup.find('> .facets-list > .facets-list__item').map(mapElementToFacet).get();
  } else if ($parents.length > 1) {
    let currentLevelFacets = $parents.first().find('.facets-list__item').map(mapElementToFacet).get();
    let parentTree = createParentTree($facet.parents('li').slice(0), currentLevelFacets);
    facets = [parentTree];
  } else {
    facets = [];
  }
  let params = {
    parameterName: $parentFilterGroup.attr('data-group-name'),
    headerText: $parentFilterGroup.parents('.facets-group').find('.facets__title').text().trim(),
    type: $parentFilterGroup.attr('data-group-type'),
    active: true,
    open: true,
    searchable: $parentFilterGroup.attr('data-is-searchable') === 'true',
    multiSelectEnabled: $parentFilterGroup.attr('data-multi-select') === 'true',
    facets: facets
  };
  return DK.Search.updateListing(href, params);
  function createParentTree(parents, childFacets) {
    let parentTree = null;
    if (parents.length > 1) {
      const parent = parents.first(),
        grandParent = parents.slice(1);
      const parentFacets = parent.map(mapElementToFacet).get();

      // There should only be one parent facet since you cannot
      // multiselect parent facets.
      if (parentFacets.length !== 1) {
        throw `Expected a single parent facet, but found ${parentFacets.length}
					parent facets.`;
      }
      let parentFacet = parentFacets[0];
      parentFacet.childFacets = childFacets;
      parentFacet.active = hasActiveChild(childFacets);
      parentTree = createParentTree(grandParent, [parentFacet]);
    } else {
      parentTree = parents.map(mapElementToFacet).first().get()[0];
      parentTree.childFacets = childFacets;
      parentTree.active = hasActiveChild(childFacets);
    }
    return parentTree;
  }
  function mapElementToFacet(index, element) {
    let $el = $(element),
      $input = $el.find('input[type="checkbox"]'),
      isActive = false;
    if ($input.length > 0) {
      isActive = $input.prop('checked');
    }
    const facetData = $el.data('facet').split('^');
    let facet = {
      filterValue: $input.attr('value'),
      fieldName: $input.attr('name'),
      url: $el.find('a').attr('href'),
      active: isActive,
      available: facetData[1] === 'true',
      count: Number.parseInt(facetData[2]),
      displayText: facetData[3],
      multiSelectable: facetData[4] === 'true',
      seoName: facetData[5]
    };
    return facet;
  }
  function hasActiveChild(children) {
    if (!children.length) {
      return false;
    }
    for (i = 0; i < children.length; i++) {
      let child = children[i];
      if (child.childFacets && child.childFacets.length) {
        return hasActiveChild(child.childFacets);
      } else if (child.active) {
        return true;
      }
    }
    return false;
  }
});
$(document).on('click', 'a.facets-list__link', function (e) {
  e.preventDefault();

  // SITE-3602/SITE-3603 the +/- icon is now part of the <a> tag itself
  // to reduce the DOM bloat of the facets.  To deal with detecting
  // that the :after was clicked rather than the link text we need to
  // see if the click occurred outside of the <a> itself and fire the
  // appropriate facet event if so.
  const self = e.currentTarget;
  const $self = $(self);
  const disableAjax = $self.parents('.facets.product-listing-facets').hasClass('disable-ajax-facets');
  if ($self.hasClass('facets__children') && e.offsetX > self.offsetWidth) {
    if ($self.hasClass('facets__children--minus')) {
      $self.trigger('facet-close');
    } else {
      $self.trigger('facet-open');
    }
    // since the click event occurred outside of the <a>(that is, on the
    // plus/minus icon) we skip the rest of the handler.
    return false;
  }
  if (disableAjax) {
    const href = $self.attr('href') ? $self.attr('href') : $self.data('url');
    window.location.href = href;
    return false;
  }
  const $facet = $(e.currentTarget).parent(),
    $checkbox = $facet.find('input');
  if ($checkbox.length) {
    if ($checkbox.prop('checked')) {
      $checkbox.prop('checked', false);
    } else {
      $checkbox.prop('checked', true);
    }
  }
  $('html, body').scrollTop(0);
  $facet.trigger('applyFilter', [$facet]);
});
$(document).on('change', '.facets__check', function (e) {
  const $facet = $(e.currentTarget).parent();
  $facet.trigger('applyFilter', [$facet]);
});
$(document).on('facet-open', '.facets-list__link.facets__children', function (e) {
  const facetOpen = $(e.currentTarget);
  facetOpen.parents('.facets-list__item').children('.facets-group__content').slideDown();
  facetOpen.removeClass('facets__children--plus').addClass('facets__children--minus');
  facetOpen.prev().addClass('facets-list__link--selected');
});
$(document).on('facet-close', '.facets-list__link.facets__children', function (e) {
  const facetClose = $(e.currentTarget);
  facetClose.siblings('.facets-group__content').slideUp();
  facetClose.removeClass('facets__children--minus').addClass('facets__children--plus');
  facetClose.prev().removeClass('facets-list__link--selected');
});
$(document).on('click', '.facets__title', function (e) {
  const toggleCollapse = $(e.currentTarget);
  const parentCollapse = toggleCollapse.parent();
  const siblingCollapse = parentCollapse.find('.facets-group__content:not(.facets__subchild)');
  if (toggleCollapse.hasClass('facets__title--hidden')) {
    toggleCollapse.removeClass('facets__title--hidden');
    siblingCollapse.slideDown();
  } else {
    siblingCollapse.slideUp(function () {
      toggleCollapse.addClass('facets__title--hidden');
    });
  }
});
$(document).on('click', 'a.clear-btn', function (e) {
  e.preventDefault();
  const href = e.currentTarget.href;
  DK.Search.updateListing(href);
  $('html, body').scrollTop(0);
});
$(document).on('click', 'a.remove-facet', function (e) {
  e.preventDefault();
  const href = e.currentTarget.href;
  DK.Search.updateListing(href);
  $('html, body').scrollTop(0);
});
$(function () {
  //Handle browser back and forward functionality
  $(window).on('popstate', function (event) {
    // Work around Safari firing popstate on page load by checking that this
    // popstate was fired for an event that we added.
    if (event.originalEvent.state.searchFilters) {
      const content = event.originalEvent.state.content;
      if (content.url === '/outlet') {
        //load the outlet home page instead of the closeout
        //product listing page.
        document.location = content.url;
      }
      DK.Search.submitRequest(content.url);
    }
  });
  $('input[data-facet-filter]').facetSearch();

  // Hack workaround for Chrome where hitting the 'Back' button from an
  // item details page would not cause checkboxes to be checked properly
  $('[data-search-filters]').find('input[checked]').not(':checked').prop('checked', true);
  $('.tgl').find('input[checked]').not(':checked').prop('checked', true);
  $(window).on('unload', function () {
    $('html, body').scrollTop(0);
  });
});
DK.Search.Seo = {
  updateSeoContent: function (data) {
    DK.Search.Seo.updatePageTitles(data.defaultTitle, data.customTitle);
    DK.Search.Seo.updateMetaDescription(data.metaDescription);
    DK.Search.Seo.updateLinkRel(data.page, data.nextPage, data.previousPage, data.defaultCanonical, data.customCanonical);
    DK.Search.Seo.updateNoIndex(data.previousPage, data.noIndex);
  },
  updateMetaDescription: function (metaDescription) {
    if (metaDescription) {
      $('meta[name=description]').attr('content', metaDescription);
    } else {
      $('meta[name=description]').attr('content', `With over 160,000 unique items ready to ship today, Dennis Kirk
				carries the largest selection of motorcycle, ATV, and
				snowmobile helmets, apparel, parts, and accessories.`);
    }
  },
  updatePageTitles: function (defaultTitle, customTitle) {
    const suffix = $("meta[property='og:title']").data('suffix');
    if (customTitle) {
      $('title').html(`${customTitle} ${suffix}`);
      $('meta[property="og:title"]').attr('content', customTitle);
    } else if (defaultTitle) {
      $('title').html(`${defaultTitle} ${suffix}`);
      $('meta[property="og:title"]').attr('content', defaultTitle);
    } else {
      $('title').html(suffix);
      $('meta[property="og:title"]').attr('content', document.title);
    }
  },
  updateContentTitle: function (defaultTitle, customTitle, isLandingPage) {
    let header = $('.body-content .page-content__header h1');
    const newTitle = isLandingPage ? defaultTitle : customTitle;
    header.text(newTitle);
  },
  updateLinkRel: function (pageNumber, nextPage, previousPage, defaultCanonical, customCanonical) {
    let $linkCanonical = $('link[rel="canonical"]');
    let canonicalUrl;
    if (customCanonical) {
      canonicalUrl = window.location.origin + customCanonical;
    } else {
      canonicalUrl = window.location.origin + defaultCanonical;
    }
    updateRelTagAttributes($linkCanonical, canonicalUrl);
    const $linkNext = $('link[rel="next"]');
    updateRelTagAttributes($linkNext, nextPage, 'next');
    const $linkPrev = $('link[rel="prev"]');
    updateRelTagAttributes($linkPrev, previousPage, 'prev');
    function updateRelTagAttributes($linkTag, pageUrl, type) {
      let $linkCanonical = $('link[rel="canonical"]');
      if (!pageUrl && $linkTag.length > 0) {
        // Remove link element when there is no url to prevent
        // empty links
        $linkTag.remove();
      } else if (pageUrl) {
        if ($linkTag.length === 0) {
          // Create link tag when it does not exist for this type
          $linkTag = $('<link/>').attr('rel', type);
          $linkCanonical.before($linkTag);
        }
        $linkTag.attr('href', pageUrl);
      }
    }
  },
  updateNoIndex: function (previousPage, noIndex) {
    if (noIndex && $('meta[name="robots"]').length < 1) {
      $('link[rel="canonical"]').before(`<meta name="robots" content="${noIndex}">`);
    } else if (!noIndex && $('meta[name="robots"]').length == 1) {
      $('meta[name="robots"]').remove();
    }
  },
  hideLongLists: function () {
    //Add see more/less links
    const list = $('.facets-group > .facets-group__content:not(.facets-group__content--cat) .facets-list:not(.facets-list--child)');
    list.each(function () {
      const thisList = $(this);
      const listItems = thisList.children(),
        listItemCount = listItems.length;
      const addtlCount = listItemCount - 5,
        addtlLink = `<button class="facets__addtl-link facets__addtl-link--more
				btn btn-link">${addtlCount} more</button>`;
      if (addtlCount >= 5) {
        //Only add the count attribute if it's over 5
        thisList.attr('data-count', addtlCount);
      }
      listItems.each(function (i, e) {
        if (i >= 5) {
          //Add a class to hide all items over 5
          $(e).addClass('facets-list__item--overcount');
        }
      });
      if (listItemCount > 5) {
        //Append a button to see more
        thisList.append(addtlLink);
      }
    });
    $('button.facets__addtl-link').on('click', function (e) {
      e.preventDefault();
      const button = $(this);
      if (button.hasClass('facets__addtl-link--more')) {
        button.siblings('li').removeClass('facets-list__item--overcount');
        button.removeClass('facets__addtl-link--more').addClass('facets__addtl-link--less').text('Show Less');
      } else {
        const addtlCount = button.parent().data('count');
        button.parent().children('li').each(function (i, e) {
          if (i >= 5) {
            $(e).addClass('facets-list__item--overcount');
          }
        });
        button.addClass('facets__addtl-link--more').removeClass('facets__addtl-link--less').text(`+ ${addtlCount} more`);
      }
    });
  }
};
(function ($) {
  const myModal = document.getElementById('filter-modal');
  /**
   * Add the modal styles to the search filter sidebar when the 'Filter'
   * button is clicked on smaller screens. This allows reusing the facet
   * sidebar on all versions of the product listing page.
   */
  myModal.addEventListener('show.bs.modal', () => {
    $(myModal).addClass('modal fade');
  });
  myModal.addEventListener('hidden.bs.modal', () => {
    $(myModal).removeClass('modal fade').removeAttr('style');
  });

  /*Prevent facet nav from disappearing on breakpoint changes*/
  //This totally doesn't work right now
  $(window).on('greaterEqualTo-lg', () => {
    if ($(myModal).hasClass('modal')) {
      bootstrap.Modal.getInstance(myModal).hide();
      $(myModal).removeClass('modal fade').removeAttr('style');
    }
  });
})(jQuery);
$(function () {
  DK.Search.Seo.hideLongLists();
});